import { render, staticRenderFns } from "./checkboxCell.vue?vue&type=template&id=0fca1eda"
import script from "./checkboxCell.vue?vue&type=script&lang=js"
export * from "./checkboxCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports